import warningRequestVacationComponent from './warningRequestVacation.component';

let warningRequestVacationModule = angular.module('vacations-absences.warningRequestVacation', [])

.component('warningRequestVacation', warningRequestVacationComponent)

.name;

export default warningRequestVacationModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/warningRequestVacation/warningRequestVacation.js